import React, { Component } from "react";
import { connect } from "react-redux";
import * as solanasActions from "../../store/actions/Index";
import * as authActions from "../../store/actions/auth";
import * as ActionTypes from "../../store/actions/ActionTypes";
import AppBar from "../../components/AppBar/AppBar";
import Container from "@material-ui/core/Container";
import SideMenu from "../../components/SideMenu/SideMenu";
import ActivitiesCalendar from "../Activities/ActivitiesCalendar";
import Users from "../Users/Users";
import Informations from "../Informations/Informations";
import Promotions from "../Promotions/Promotions";
import Principal from "../Principal/Principal";
import Photos from "../Photos/Photos";
import Favourites from "../Favourites/Favourites";

class Manager extends Component {
	state = {
		fieldValues: {
			image: ""
		},
		loading: false,
		decisionModalOpen: false,
		modifyFormModalOpen: false,
		modifyTextFormOpen: false,
		idToDelete: 0,
		idToUpdate: 0,
		deleting: false
	};

	componentDidMount() {
		this.props.onLoadUsers(this.props.token);
		this.props.loadInformations();
		this.props.loadFavourites();
		this.props.loadPromotions();
		this.props.loadPrincipal();
		this.props.loadPhotos();

	}

	handleSideMenu = () => {
		this.setState({ sideMenuOpen: !this.state.sideMenuOpen });
	};

	render() {
		const containerStyle = {
			marginTop: "50px"
		};

		let informations = this.props.informationsMenuOpen ? (
			<Informations
				informations={this.props.informations}
				loadInformations={this.props.loadInformations}
				handleSaveButton={this.props.saveInformation}
				token={this.props.token}
			/>
		) : null;

		let users = this.props.usuariosMenuOpen ? (
			<Users
				users={this.props.usersList}
				onClickDeleteButton={this.showDecisionModal}
				token={this.props.token}
			/>
		) : null;

		let favourites = this.props.favouritesMenuOpen ? (
			<Favourites favourites={this.props.favouritesList} />
		) : null;

		let promotions = this.props.promotionsMenuOpen ? (
			<Promotions
				promotions={this.props.promotionsList}
				onUploadImage={this.props.onUploadImage}
				handleDelete={this.props.deletePromocion}
				handleSave={this.props.savePromocion}
				handleCreate={this.props.createPromocion}
				token={this.props.token}
			/>
		) : null;

		let principal = this.props.principalMenuOpen ? (
			<Principal
				principal={this.props.principalList}
				handleDelete={this.props.deletePrincipal}
				handleSave={this.props.savePrincipal}
				handleCreate={this.props.createPrincipal}
				token={this.props.token}
			/>
		) : null;

		let calendar = this.props.calendarMenuOpen ? (
			<ActivitiesCalendar
				loadActivities={this.props.loadActivities}
				saveActivities={this.props.saveActivities}
				updateActivities={this.props.updateActivities}
				deleteActivity={this.props.deleteActivity}
				activities={this.props.activities}
				token={this.props.token}
			/>
		) : null;

		
		let galleryPhotos = this.props.photosMenuOpen ? (
			<Photos
				photos={this.props.photos}
/*				savePhotos={this.props.saveActivities}
				updateActivities={this.props.updateActivities}
				deleteActivity={this.props.deleteActivity}
				activities={this.props.activities}*/
				token={this.props.token}
				handleInsert={this.props.handleInsertEvent}
			/>
		) : null;

		return (
			<div>
				<AppBar
					openMenu={this.props.handleOpenSideMenu}
					onClickLogout={this.props.handleLogout}
				/>
				<SideMenu
					open={this.props.sideMenuOpen}
					handleOpenUsuarios={this.props.handleOpenUsuarios}
					handleOpenActividades={this.props.handleOpenActividades}
					handleOpenInformations={this.props.handleOpenInformations}
					handleOpenFavourites={this.props.handleOpenFavoritos}
					handleOpenPromotions={this.props.handleOpenPromotions}
					handleOpenPrincipal={this.props.handleOpenPrincipal}
					handleOpenPhotos={this.props.handleOpenPhotos}
				/>
				<Container fixed style={containerStyle}>
					{informations}
					{users}
					{calendar}
					{favourites}
					{promotions}
					{principal}
					{galleryPhotos}
				</Container>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		activities: state.reducer.activities,
		informations: state.reducer.informations,
		photos: state.reducer.photos,
		sideMenuOpen: state.reducer.sideMenuOpen,
		usuariosMenuOpen: state.reducer.usuariosMenuOpen,
		calendarMenuOpen: state.reducer.calendarMenuOpen,
		favouritesMenuOpen: state.reducer.favouritesMenuOpen,
		informationsMenuOpen: state.reducer.informationsMenuOpen,
		promotionsMenuOpen: state.reducer.promotionsMenuOpen,
		principalMenuOpen: state.reducer.principalMenuOpen,
		photosMenuOpen: state.reducer.photosMenuOpen,
		token: state.authReducer.token,
		usersList: state.reducer.users,
		favouritesList: state.reducer.favourites,
		promotionsList: state.reducer.promotions,
		principalList: state.reducer.principal
	};
};

const mapDispatchToProps = dispatch => {
	return {
		loadActivities: () => dispatch(solanasActions.loadActivities()),
		loadFavourites: () => dispatch(solanasActions.loadFavourites()),
		loadPromotions: () => dispatch(solanasActions.loadPromotions()),
		loadPrincipal: () => dispatch(solanasActions.loadPrincipal()),
		loadPhotos: () => dispatch(solanasActions.loadPhotos()),
		savePromocion: (promocion, token) =>
			dispatch(solanasActions.savePromotions(promocion, token)),
		createPromocion: (promocion, token) =>
			dispatch(solanasActions.uploadImageAndCreatePromotion(promocion, token)),
		deletePromocion: (promocion, token) =>
			dispatch(solanasActions.deletePromotion(promocion, token)),

		savePrincipal: (principal, token) =>
			dispatch(solanasActions.savePrincipal(principal, token)),
		createPrincipal: (principal, token) =>
			dispatch(solanasActions.uploadImageAndCreatePrincipal(principal, token)),
		deletePrincipal: (principal, token) =>
			dispatch(solanasActions.deletePrincipal(principal, token)),

		saveActivities: activity =>
			dispatch(solanasActions.saveActivities(activity)),
		updateActivities: activity =>
			dispatch(solanasActions.updateActivities(activity)),
		deleteActivity: activity =>
			dispatch(solanasActions.deleteActivity(activity)),
		loadInformations: () => dispatch(solanasActions.loadInformations()),
		saveInformation: (information, token) =>
			dispatch(solanasActions.saveInformation(information, token)),

		onLoadUsers: token => dispatch(solanasActions.loadUsers(token)),

		handleOpenSideMenu: () =>
			dispatch({ type: ActionTypes.OPENCLOSE_SIDEMENU }),
		handleOpenForm: () => dispatch({ type: ActionTypes.OPEN_FORMMENU }),
		handleOpenUsuarios: () => dispatch({ type: ActionTypes.OPEN_USUARIOS }),
		handleOpenFavoritos: () => dispatch({ type: ActionTypes.OPEN_FAVOURITES }),
		handleOpenPromotions: () => dispatch({ type: ActionTypes.OPEN_PROMOTIONS }),
		handleOpenPrincipal: () => dispatch({ type: ActionTypes.OPEN_PRINCIPAL }),
		handleOpenPhotos: () => dispatch({ type: ActionTypes.OPEN_PHOTOS }),
		handleInsertEvent: (eventname, photos, token) => dispatch(solanasActions.insertEvent(eventname, photos, token)),
		handleOpenActividades: () =>
			dispatch({ type: ActionTypes.OPEN_ACTIVITIES }),
		handleOpenInformations: () =>
			dispatch({ type: ActionTypes.OPEN_INFORMATIONS }),
		handleLogout: () => dispatch(authActions.authLogOut())
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Manager);
